import { ref, reactive, onMounted } from "vue";

export default function useReviews(data: any) {
    const reviews = ref<any[]>([]);
    const loading = ref(true);

    const formData = reactive({
        pageSize: 20,
        total: 0,
        currentPage: 1,
        sort: "",
        filter: "All",
        rate: "All",
    });

    const averageRating = ref(5.0);

    const showData = computed(() => {
        let result = JSON.parse(JSON.stringify(reviews.value));
        if (formData.filter !== "All") {
            result = result.filter((review: any) => review.products[0].product_name === formData.filter);
        }
        if (formData.rate !== "All") {
            result = result.filter((review: any) => review.ratings.value === formData.rate);
        }
        formData.total = result.length;
        const start = (formData.currentPage - 1) * formData.pageSize;
        const end = start + formData.pageSize;
        result = result.slice(start, end);
        return result;
    });

    const sortType = ["Newest First", "Oldest First", "Highest Rating"];
    const reviewSort = (type: string) => {
        switch (type) {
            case "Newest First":
                formData.sort = "Newest First";
                reviews.value.sort((a, b) => {
                    return new Date(b.review_timestamp).getTime() - new Date(a.review_timestamp).getTime();
                });
                break;
            case "Oldest First":
                formData.sort = "Oldest First";
                reviews.value.sort((a, b) => {
                    return new Date(a.review_timestamp).getTime() - new Date(b.review_timestamp).getTime();
                });
                break;
            case "Highest Rating":
                formData.sort = "Highest Rating";
                reviews.value.sort((a, b) => b.ratings.value - a.ratings.value);
                break;

            default:
                break;
        }
    };

    const getReviews = async () => {
        loading.value = true;
        try {
            const result = data.value;
            reviews.value = result.reviews;
            formData.total = reviews.value.length;
            averageRating.value = calculateAverageRating(reviews.value);
            console.log(showData.value);
        } catch (err) {
            console.error("Error fetching reviews:", err);
        } finally {
            loading.value = false;
        }
    };

    function calculateAverageRating(reviews: any[]): number {
        const totalRating = reviews.reduce((sum, review) => {
            return sum + (review.ratings?.value ?? 0);
        }, 0);
        return parseFloat((totalRating / formData.total).toFixed(1));
    }

    onMounted(() => {
        getReviews();
    });

    return { showData, actions: { reviewSort }, reviews, loading, formData, averageRating, sortType };
}
